/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Errortitle2Inputs */

const en_signin_errortitle2 = /** @type {(inputs: Signin_Errortitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in failed`)
};

const fr_signin_errortitle2 = /** @type {(inputs: Signin_Errortitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la connexion`)
};

/**
* | output |
* | --- |
* | "Sign-in failed" |
*
* @param {Signin_Errortitle2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_errortitle2 = /** @type {((inputs?: Signin_Errortitle2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Errortitle2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_errortitle2(inputs)
	return fr_signin_errortitle2(inputs)
});
export { signin_errortitle2 as "signIn_errorTitle" }